import type { FeedbackArtifact } from '@nimbalyst/collab-protocol';

import { getProjectRouteId, resolveProjectSelection } from '../projectSelection';
import { orgDocumentPath, type RouteTeam } from '../routing';

/**
 * Resolve a feedback artifact without inventing a project room.
 *
 * Current requests carry the owning project id. A legacy ref without one is
 * safe only when the organization exposes exactly one project; choosing the
 * first of several would route the document id through the wrong room.
 */
export function feedbackSubjectDocumentPath(
  team: RouteTeam,
  subject: FeedbackArtifact,
): string | null {
  if (subject.ref.kind !== 'document') return null;
  const projects = team.projects ?? [];
  const project = subject.ref.projectId
    ? resolveProjectSelection(projects, subject.ref.projectId)
    : projects.length === 1
      ? projects[0]!
      : null;
  if (!project) return null;
  return orgDocumentPath(team, getProjectRouteId(project), subject.ref.sourceId);
}
